<template>
  <div>
    <div id="FcRenderer" class="vx-row" v-if="appData" @contextmenu.prevent>
      <!--- LEARN APP START --->
      <div class="FcAppScreen w-3/4 flex items-center justify-center overflow-hidden">
        <div class="FcAppParent">
          <div class="FcAppContainer">
            <div class="fcLeftArrow cursor-pointer" @click="previousTerm">
              <feather-icon icon="ArrowLeftIcon" svgClasses="h-32 w-32" />
            </div>

            <div class="fcCard">
              <slide-y-down-transition :duration="200">
                <div class="mb-8" v-if="showCard">
                  <flash-card-view
                    v-if="!enableEditMode"
                    :ref="'flashCardView'"
                    :key="activeTermIndex"
                    :text-front="currentTerm.term"
                    :text-back="currentTerm.definition"
                    :img-front="currentTerm.term_image"
                    :img-back="currentTerm.definition_image"
                    :flagged-term="progressData.terms_flagged.includes(currentTerm.id)"
                    :lottie-animation="settings.lottieAnimation"
                    :default-side="settings.defaultCardSide"
                    :card-color="settings.defaultCardColor"
                    v-on:flipped="flippedCard"
                  >
                  </flash-card-view>
                  <flash-card-admin
                    v-if="enableEditMode"
                    :key="activeTermIndex"
                    :flagged-term="progressData.terms_flagged.includes(currentTerm.id)"
                    :term-data="currentTerm"
                    v-on:flipped="flippedCard"
                  >
                  </flash-card-admin>
                </div>
              </slide-y-down-transition>

              <div class="flex justify-center items-center">
                <vs-button
                  color="primary"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-fast-forward"
                  class="mr-10 font-bold"
                  @click="jumpTermPopup = !jumpTermPopup"
                  >Jump
                </vs-button>
                <p class="font-light text-center" style="font-size: 24px">{{ setTermIndex + 1 }} / {{ setDetails.terms_count }}</p>
                <vs-button
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-flag"
                  class="ml-10 font-bold"
                  :color="progressData.terms_flagged.includes(currentTerm.id) ? 'success' : 'danger'"
                  @click="toggleFlagged(currentTerm.id)"
                  id="flagBtn"
                >
                  {{ progressData.terms_flagged.includes(currentTerm.id) ? 'Unflag' : 'Flag' }}
                </vs-button>
              </div>
            </div>
            <div class="fcRightArrow cursor-pointer" @click="nextTerm">
              <feather-icon icon="ArrowRightIcon" svgClasses="h-32 w-32" />
            </div>
          </div>
        </div>
      </div>

      <!--- TOP INFO START --->
      <div class="vx-col w-1/4 mb-3">
        <vx-card class="mb-5">
          <div class="flex items-center justify-between">
            <div>
              <h1 class="font-bold" style="margin-bottom: 2px">{{ setData.name }}</h1>
              <p class="font-light">{{ setDetails.terms_count }} Total Terms</p>
            </div>
            <img
              :src="setData.thumbnail"
              v-if="setData.thumbnail"
              width="75"
              height="75"
              class="rounded shadow-md cursor-pointer"
              draggable="false"
              alt=""
            />
          </div>
        </vx-card>

        <vx-card class="mb-5">
          <!---<div class="flex justify-between items-center mb-3">
            <h2 class="font-bold">Set Progress</h2>
            <h2 class="font-light">{{ progressSummary.percent }}%</h2>
          </div>--->
          <div class="grid grid-cols-2 gap-4">
            <div class="flex flex-col justify-center">
              <div class="flex items-center mb-2">
                <h2 class="font-bold">Set Progress</h2>
              </div>
              <div class="flex items-center mb-2">
                <feather-icon icon="CheckCircleIcon" svgClasses="h-6 w-6 mr-2 text-success" />
                <h5 class="font-bold mr-2">Terms Completed</h5>
                <h5 class="font-light">{{ progressSummary.terms_completed }}</h5>
              </div>
              <div class="flex items-center mb-2">
                <feather-icon icon="XCircleIcon" svgClasses="h-6 w-6 mr-2 text-danger" />
                <h5 class="font-bold mr-2">Terms Remaining</h5>
                <h5 class="font-light">{{ progressSummary.terms_remaining }}</h5>
              </div>
              <div class="flex items-center">
                <feather-icon icon="FlagIcon" svgClasses="h-6 w-6 mr-2 text-warning" />
                <h5 class="font-bold mr-2">Terms Flagged</h5>
                <h5 class="font-light">{{ progressSummary.terms_flagged }}</h5>
              </div>
            </div>
            <div class="flex justify-end items-center">
              <radial-progress-bar
                :diameter="115"
                :completed-steps="progressSummary.terms_completed"
                :total-steps="progressSummary.terms_count"
                :animateSpeed="1100"
                timingFunc="ease"
                innerStrokeColor="#0000006b"
                startColor="#0cdc62"
                stopColor="#0cdc62"
                :strokeWidth="7"
                :innerStrokeWidth="7"
              >
                <h2 class="font-light">{{ progressSummary.percent }}%</h2>
              </radial-progress-bar>
            </div>
          </div>
        </vx-card>

        <vx-card class="mb-5">
          <div class="flex justify-between items-center mb-3">
            <h2 class="font-bold">Options</h2>
            <div class="flex items-center justify-start align-middle mt-1" v-if="$acl.check('proctor')">
              <p class="mr-2 font-light">Admin Mode</p>
              <vs-switch v-model="enableEditMode" color="success"></vs-switch>
            </div>
          </div>
          <div class="flex items-center mb-3">
            <feather-icon icon="FilterIcon" svgClasses="h-6 w-6 mr-2 text-primary" />
            <h5 class="font-bold">
              Current Filter
              <span class="font-light">
                - {{ filterSelected !== '' ? filterSelected.charAt(0).toUpperCase() + filterSelected.slice(1) : 'Not Enabled' }}</span
              >
            </h5>
          </div>

          <div class="grid grid-cols-2 gap-3">
            <vs-button
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-filter"
              class="w-full font-bold"
              @click="filterPopup = !filterPopup"
              >Filter Terms
            </vs-button>
            <vs-button
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-search"
              class="w-full font-bold"
              @click="searchTermPopup = !searchTermPopup"
              >Search Terms
            </vs-button>
            <vs-button
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-settings"
              class="w-full font-bold"
              @click="settingsPopup = !settingsPopup"
              >Settings
            </vs-button>
            <vs-button
              color="danger"
              type="gradient"
              icon-pack="feather"
              icon="icon-arrow-left"
              class="w-full font-bold"
              @click="$router.push('/flashcards/select')"
              >Exit
            </vs-button>
          </div>
        </vx-card>

        <vx-card>
          <div class="flex items-center">
            <feather-icon icon="InfoIcon" svgClasses="h-7 w-7 mr-2" />
            <h6 class="ml-2">In Order To Complete A Set You Must Go Through Each Term Without Skipping</h6>
          </div>
        </vx-card>
      </div>

      <!--- POPUP MODALS --->
      <vs-popup :active.sync="jumpTermPopup" title="Jump To Term">
        <div class="p-2 popup-input">
          <div class="flex items-center mb-4">
            <feather-icon icon="InfoIcon" svgClasses="h-8 w-8 mr-1" />
            <h3 class="ml-1">Enter A Term Number Between 1 and {{ setDetails.terms_count }}</h3>
          </div>

          <div class="mb-5">
            <vs-input
              v-model="jumpTermValue"
              class="w-full"
              placeholder="Term Number"
              v-validate="`between:1,${setDetails.terms_count}`"
              name="Jump"
            />
            <span class="text-danger text-sm" v-show="errors.has('Jump')">{{ errors.first('Jump') }}</span>
          </div>

          <vs-button
            color="primary"
            type="gradient"
            icon-pack="feather"
            icon="icon-fast-forward"
            :disabled="!jumpTermValue || errors.has('Jump')"
            @click="jumpToTermByNumber"
            >Jump To Term
          </vs-button>
        </div>
      </vs-popup>
      <vs-popup :active.sync="filterPopup" class="pb-3" title="Set Filter">
        <div>
          <vx-card class="mb-3">
            <div class="vx-row">
              <div class="vx-col w-1/5 sm:w-0/5 flex items-center justify-center">
                <feather-icon :icon="'CheckCircleIcon'" svg-classes="h-16 w-16 text-success" />
              </div>
              <div class="vx-col w-3/5 sm:w-2/5 flex flex-col justify-center">
                <h4 class="mb-2 font-semibold">Completed Terms</h4>
                <h6 class="font-light">{{ progressSummary.terms_completed }} Terms</h6>
              </div>
              <div class="vx-col w-2/5 align-middle justify-center">
                <vs-button
                  class="shadow-lg font-semibold w-full my-2"
                  icon="icon-filter"
                  icon-pack="feather"
                  type="gradient"
                  :color="filterSelected === 'completed' ? 'danger' : 'primary'"
                  @click="selectFilter('completed')"
                >
                  {{ filterSelected === 'completed' ? 'Disable Filter' : 'Enable Filter' }}
                </vs-button>
              </div>
            </div>
          </vx-card>
          <vx-card class="mb-3">
            <div class="vx-row">
              <div class="vx-col w-1/5 sm:w-0/5 flex items-center justify-center">
                <feather-icon :icon="'XCircleIcon'" svg-classes="h-16 w-16 text-warning" />
              </div>
              <div class="vx-col w-3/5 sm:w-2/5 flex flex-col justify-center">
                <h4 class="mb-2 font-semibold">Remaining Terms</h4>
                <h6 class="font-light">{{ progressSummary.terms_remaining }} Terms</h6>
              </div>
              <div class="vx-col w-2/5 align-middle justify-center">
                <vs-button
                  class="shadow-lg font-semibold w-full my-2"
                  icon="icon-filter"
                  icon-pack="feather"
                  type="gradient"
                  :color="filterSelected === 'remaining' ? 'danger' : 'primary'"
                  @click="selectFilter('remaining')"
                >
                  {{ filterSelected === 'remaining' ? 'Disable Filter' : 'Enable Filter' }}
                </vs-button>
              </div>
            </div>
          </vx-card>
          <vx-card>
            <div class="vx-row">
              <div class="vx-col w-1/5 sm:w-0/5 flex items-center justify-center">
                <feather-icon :icon="'FlagIcon'" svg-classes="h-16 w-16 text-danger" />
              </div>
              <div class="vx-col w-3/5 sm:w-2/5 flex flex-col justify-center">
                <h4 class="mb-2 font-semibold">Flagged Terms</h4>
                <h6 class="font-light">{{ progressSummary.terms_flagged }} Terms</h6>
              </div>
              <div class="vx-col w-2/5 align-middle justify-center">
                <vs-button
                  class="shadow-lg font-semibold w-full my-2"
                  icon="icon-filter"
                  icon-pack="feather"
                  type="gradient"
                  :color="filterSelected === 'flagged' ? 'danger' : 'primary'"
                  @click="selectFilter('flagged')"
                >
                  {{ filterSelected === 'flagged' ? 'Disable Filter' : 'Enable Filter' }}
                </vs-button>
              </div>
            </div>
          </vx-card>
        </div>
      </vs-popup>
      <vs-popup :active.sync="searchTermPopup" title="Search for Term">
        <vs-table :data="searchTermResults" :sst="true" max-items="5">
          <template slot="header">
            <div class="rounded-t-lg pt-3 pb-2 w-full">
              <div class="flex items-center justify-between">
                <h3 class="ml-4">Terms</h3>
                <vs-input
                  icon-pack="feather"
                  icon="icon-search"
                  placeholder="Search Terms"
                  v-model="searchTermQuery"
                  class="mr-2"
                  @input="fetchTermsData"
                />
              </div>
            </div>
          </template>

          <template slot="thead">
            <vs-th>Term</vs-th>
            <vs-th>Definition</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="attach in data" :key="attach.id">
              <vs-td :data="attach.term" class="w-2/5">
                <div class="flex items-center">
                  <feather-icon
                    v-if="progressData.terms_completed.includes(attach.id)"
                    :icon="'CheckCircleIcon'"
                    svg-classes="h-6 w-6 mr-2 text-success"
                  />
                  <feather-icon v-else :icon="'XCircleIcon'" svg-classes="h-6 w-6 mr-2 text-danger"></feather-icon>
                  <feather-icon
                    v-if="progressData.terms_flagged.includes(attach.id)"
                    :icon="'FlagIcon'"
                    svg-classes="h-6 w-6 mr-2 text-warning"
                  />
                  {{ attach.term.substring(0, 55) }}{{ attach.term.length > 55 ? '...' : '' }}
                </div>
              </vs-td>

              <vs-td :data="attach.definition" class="w-2/5">
                {{ attach.definition.substring(0, 55) }}{{ attach.definition.length > 55 ? '...' : '' }}
              </vs-td>

              <vs-td>
                <vs-button color="primary" size="small" icon-pack="feather" icon="icon-eye" @click="jumpToTermBySearch(attach.id)">
                  View
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="rounded-b-lg rounded-t-none pb-3 pt-4 vs-con-table">
          <vs-pagination :total="Math.ceil(searchTermCount / searchTermAmount)" v-model="searchTermPage" class="pr-2"></vs-pagination>
        </div>
      </vs-popup>
      <vs-popup :active.sync="settingsPopup" class="pb-3" title="Settings">
        <div class="p-2 pt-0">
          <h1 class="mb-5">FlashCard Settings</h1>

          <div class="flex p-3 rounded-lg mb-5 vx-card">
            <vs-switch color="success" v-model="settings.keyboardShortcuts" class="mr-3" />
            <h4>Keyboard Shortcuts</h4>
          </div>
          <div class="flex p-3 rounded-lg mb-5 vx-card">
            <vs-switch color="success" v-model="settings.lottieAnimation" class="mr-3" />
            <h4>Lottie Animations</h4>
          </div>
          <div class="p-3 rounded-lg mb-5 vx-card">
            <h4 class="mb-3">Default Card Side</h4>
            <div class="flex items-center">
              <vs-radio v-model="settings.defaultCardSide" vs-value="term" vs-name="defaultCardSide" class="mr-3">Term</vs-radio>
              <vs-radio v-model="settings.defaultCardSide" vs-value="definition" vs-name="defaultCardSide">Definition</vs-radio>
            </div>
          </div>
          <div class="p-3 rounded-lg vx-card">
            <h4 class="mb-3">Default Card Color</h4>
            <div class="flex items-center">
              <vs-radio
                v-model="settings.defaultCardColor"
                color="white"
                vs-value="#0059ff"
                vs-name="defaultCardColor"
                class="mr-3 p-2 font-bold rounded-lg"
                style="background: #0059ff"
                >Blue</vs-radio
              >
              <vs-radio
                v-model="settings.defaultCardColor"
                color="white"
                vs-value="#10AC84"
                vs-name="defaultCardColor"
                class="mr-3 p-2 font-bold rounded-lg"
                style="background: #10ac84"
                >Green</vs-radio
              >
              <vs-radio
                v-model="settings.defaultCardColor"
                color="white"
                vs-value="#fd4445"
                vs-name="defaultCardColor"
                class="mr-3 p-2 font-bold rounded-lg"
                style="background: #fd4445"
                >Red</vs-radio
              >
              <vs-radio
                v-model="settings.defaultCardColor"
                color="white"
                vs-value="#ff9f43"
                vs-name="defaultCardColor"
                class="mr-3 p-2 font-bold rounded-lg"
                style="background: #ff9f43"
                >Orange</vs-radio
              >
              <vs-radio
                v-model="settings.defaultCardColor"
                color="white"
                vs-value="#5f27cd"
                vs-name="defaultCardColor"
                class="mr-3 p-2 font-bold rounded-lg"
                style="background: #5f27cd"
                >Purple</vs-radio
              >
              <vs-radio
                v-model="settings.defaultCardColor"
                color="white"
                vs-value="#f368e0"
                vs-name="defaultCardColor"
                class="mr-3 p-2 font-bold rounded-lg"
                style="background: #f368e0"
                >Pink</vs-radio
              >
            </div>
          </div>
        </div>
      </vs-popup>
      <vs-popup :active.sync="setCompletePopup" class="pb-3" title="Set Complete">
        <div>
          <div class="flex justify-center mt-3 mb-5">
            <img src="https://cdn.discordapp.com/attachments/845520647710834708/845539218570084372/payment.png" width="150" alt="Check" />
          </div>
          <h1 class="text-center font-bold my-6" style="font-size: 42px">Set Complete</h1>
          <h3 class="text-center font-light mb-3">Keep Up The Good Work!</h3>
          <h3 class="text-center font-light mb-3">
            You Have Completed All The Terms<br />
            In The {{ setData.name }} Set
          </h3>
          <div class="flex justify-center mt-3">
            <vs-button class="mt-5 mb-5" color="success" @click="setCompletePopup = false">Continue</vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
    <div v-else class="simple-spinner">
      <span></span>
    </div>
  </div>
</template>

<script>
import FlashCardView from './components/FlashCardView'
import FlashCardAdmin from './components/FlashCardAdmin'
import RadialProgressBar from 'vue-radial-progress'

export default {
  data () {
    return {
      appData: null,
      returnedData: null,
      setDetails: null,
      nextAppData: null,
      prevAppData: null,
      setTermIndex: 0,
      activeTermIndex: 0,
      activeTerms: [],

      progressData: null,
      progressSummary: {
        terms_count: 0,
        terms_remaining: 0,
        terms_completed: 0,
        terms_flagged: 0,
        current_term: 0,
        percent: 0
      },

      setCompletePopup: false,

      jumpTermPopup: false,
      jumpTermValue: '',

      searchTermPopup: false,
      searchTermQuery: '',
      searchTermPage: 1,
      searchTermResults: [],
      searchTermCount: 0,
      searchTermAmount: 5,

      filterPopup: false,
      filterSelected: '',

      checkButton: false,
      finishedLesson: false,

      settingsPopup: false,
      settings: {
        defaultCardSide: 'term',
        defaultCardColor: '#0059ff',
        randomizeColors: false,
        lottieAnimation: true,
        keyboardShortcuts: true
      },

      showCard: false,
      enableCardButtons: true,
      enableFlagButton: true,
      cardAnimationActive: false,

      enableEditMode: false,

      setData: null
    }
  },
  components: {
    FlashCardView,
    FlashCardAdmin,
    RadialProgressBar
  },
  computed: {
    currentTerm () {
      return this.activeTerms[this.activeTermIndex]
    }
  },
  watch: {
    activeTermIndex () {
      if (this.activeTermIndex >= 9) {
        this.fetchFlipperData('next', Math.round(this.setTermIndex / 10 + 1))
      }
      if (this.activeTermIndex < 1 && this.setTermIndex > 1) {
        this.fetchFlipperData('prev', Math.round(this.setTermIndex / 10))
      }
    },
    setTermIndex () {
      const index = this.setData.terms.indexOf(this.currentTerm.id)
      if (index <= -1) return
      this.fetchProgressData('', { current_term_index: index })
    },
    searchTermPage () {
      this.fetchTermsData()
    },
    settings: {
      handler () {
        localStorage.setItem('flashCardSettings', JSON.stringify(this.settings))
      },
      deep: true
    }
  },
  methods: {
    alertInfo (title, msg) {
      this.$vs.notify({
        color: 'primary',
        title,
        text: msg,
        icon: 'feather',
        iconPack: 'icon-info'
      })
    },
    cardTransition () {
      if (this.cardAnimationActive === true) return false
      this.cardAnimationActive = true
      this.showCard = false
      setTimeout(() => {
        this.showCard = true
        this.cardAnimationActive = false
      }, 199)
    },
    flippedCard () {
      const termId = this.activeTerms[this.activeTermIndex].id
      if (!this.progressData.terms_completed.includes(termId)) {
        this.fetchProgressData('', {
          completed_term_id: termId
        })
      }
    },
    fetchSetDetails () {
      this.$http
        .get(`app/flashcards/${this.$route.params.setId}`)
        .then((response) => {
          if (response.status === 200) {
            this.setData = response.data.data

            if (this.setData.terms.length === 0) {
              this.$vs.notify({
                title: 'Error While Loading FlashCards',
                text: 'There are no terms in the set you are trying to practice',
                icon: 'feather',
                iconPack: 'icon-x-circle',
                color: 'danger',
                position: 'top-right'
              })
              return this.$router.push('/flashcards/select')
            }

            this.fetchProgressData('init')
            this.fetchTermsData()
          }
        })
        .catch(() => {})
    },
    fetchFlipperData (action, page = '', index = '') {
      this.enableCardButtons = false
      this.$http
        .get(`app/flashcards/${this.$route.params.setId}/flipper?page=${page}&index=${index}&filter=${this.filterSelected}`)
        .then((response) => {
          const password = 'SUPERSECUREPASSWORDIFYOURREADINGTHISYOUWILLBESUED123+'
          const decrypted = JSON.parse(this.$CryptoJS.AES.decrypt(response.data.data, password).toString(this.CryptoJS.enc.Utf8))

          if (response.status === 200) {
            this.enableCardButtons = true

            if (action === 'init') {
              this.updateAppData(decrypted, 0)
            }

            if (action === 'index') {
              const active_index = index - decrypted.returned.starting_index
              this.updateAppData(decrypted, active_index)
              this.setTermIndex = index
            }

            if (action === 'next') {
              this.nextAppData = decrypted
            }

            if (action === 'prev') {
              this.prevAppData = decrypted
            }
          }
        })
        .catch(() => {})
    },
    fetchProgressData (action, body = {}) {
      this.$http
        .post(`app/flashcards/${this.$route.params.setId}/progress`, body)
        .then((response) => {
          if (response.status === 200) {
            this.progressData = response.data.data.progress
            this.progressSummary = response.data.data.summary
            const actions = response.data.data.action

            actions.forEach((action) => {
              if (action === 'set_complete') {
                this.setComplete()
              }
            })

            if (action === 'init') {
              const current_term = this.progressSummary.current_term
              if (current_term && current_term > 0) {
                this.fetchFlipperData('index', '', current_term)
              } else {
                this.fetchFlipperData('init', 1)
              }
            }

            if (action === 'flag') {
              setTimeout(() => {
                this.enableFlagButton = true
              }, 450)
            }
          }
        })
        .catch(() => {})
    },
    fetchTermsData () {
      this.$http
        .get(
          `app/flashcards/${this.$route.params.setId}/terms?amount=${this.searchTermAmount}&page=${this.searchTermPage}&search=${this.searchTermQuery}`,
        )
        .then((response) => {
          const password = 'SUPERGOODPASSWORDWOWIFYOURREADINGTHISYOUWILLBESUED938+'
          const decrypted = JSON.parse(this.$CryptoJS.AES.decrypt(response.data.data, password).toString(this.CryptoJS.enc.Utf8))

          if (response.status === 200) {
            this.searchTermResults = decrypted.terms
            this.searchTermCount = decrypted.count
          }
        })
        .catch(() => {})
    },
    jumpToTermByNumber () {
      if (this.errors.has('Jump')) return
      this.cardTransition()
      this.timeoutCardButton()
      this.fetchFlipperData('index', '', this.jumpTermValue - 1)
      this.jumpTermValue = null
      this.jumpTermPopup = false
    },
    jumpToTermBySearch (id) {
      const index = this.setData.terms.indexOf(id)
      if (index <= -1) return
      this.cardTransition()
      this.timeoutCardButton()
      this.fetchFlipperData('index', '', index)
      this.searchTermQuery = ''
      this.searchTermPopup = false
    },
    keyPressed (e) {
      if (this.settings.keyboardShortcuts && !this.searchTermPopup && !this.jumpTermPopup && !this.filterPopup && !this.enableEditMode) {
        if (e.code === 'ArrowRight' || e.code === 'Enter' || e.key.toLowerCase() === 'd') {
          this.nextTerm()
        }
        if (e.code === 'ArrowLeft' || e.key.toLowerCase() === 'a') {
          this.previousTerm()
        }
        if (
          e.code === 'Space' ||
          e.code === 'ArrowUp' ||
          e.code === 'ArrowDown' ||
          e.key.toLowerCase() === 's' ||
          e.key.toLowerCase() === 'w'
        ) {
          this.$refs.flashCardView.flipCard()
        }
      }
    },
    nextTerm () {
      if (!this.enableCardButtons) return
      this.cardTransition()
      this.timeoutCardButton()
      if (this.setTermIndex + 1 >= this.setDetails.terms_count) return this.alertInfo('Reached The End Of The Set', 'Make Sure To Go Through All Terms Without Skipping To Complete The Set')
      if (this.activeTermIndex >= 9) {
        if (this.appData.returned === this.nextAppData.returned) {
          return this.alertInfo('Loading Terms', 'Try Again In A Couple Seconds')
        }
        this.updateAppData(this.nextAppData, 0)
        this.setTermIndex++
      } else {
        this.setTermIndex++
        this.activeTermIndex++
      }
    },
    previousTerm () {
      if (!this.enableCardButtons) return
      this.cardTransition()
      this.timeoutCardButton()
      if (this.setTermIndex <= 0) return this.alertInfo('Reached The Beginning Of The Set', 'Make Sure To Go Through All Terms Without Skipping To Complete The Set')
      if (this.activeTermIndex < 1) {
        if (this.appData.returned === this.prevAppData.returned) {
          return this.alertInfo('Loading Terms', 'Try Again In A Couple Seconds')
        }
        this.updateAppData(this.prevAppData, 9)
        this.setTermIndex--
      } else {
        this.setTermIndex--
        this.activeTermIndex--
      }
    },
    timeoutCardButton () {
      this.enableCardButtons = false
      setTimeout(() => {
        this.enableCardButtons = true
      }, 450)
    },
    toggleFlagged (id) {
      if (!this.enableFlagButton) return
      this.enableFlagButton = false
      const flagged = this.progressData.terms_flagged.includes(id)
      if (flagged) {
        if (this.filterSelected === 'flagged') {
          this.$vs.notify({
            color: 'warning',
            title: 'Flagged Term Removed',
            text: 'The Flagged Term Will Be Removed Next Time You Enable The Flagged Filter',
            icon: 'feather',
            iconPack: 'icon-info'
          })
        }
        this.fetchProgressData('flag', { remove_flagged_term: id })
      } else {
        this.fetchProgressData('flag', { add_flagged_term: id })
      }
    },
    setComplete () {
      this.$confetti.start({})

      setTimeout(() => {
        this.$confetti.stop()
      }, 3000)

      this.flashCardCompleteSound.play()
      this.setCompletePopup = true
    },
    selectFilter (filter) {
      const validFilters = ['completed', 'remaining', 'flagged']
      if (!validFilters.includes(filter)) return
      if (filter === this.filterSelected) filter = ''
      this.filterSelected = filter
      this.fetchFlipperData('init', 1)
      this.setTermIndex = 0
    },
    updateAppData (appData, index = 0) {
      this.enableCardButtons = false
      this.appData = appData
      this.activeTerms = this.appData.terms
      this.returnedData = this.appData.returned
      this.setDetails = this.appData.set
      this.activeTermIndex = index
      this.enableCardButtons = true
    }
  },
  mounted () {
    this.flashCardCompleteSound = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Success.mp3')
    window.flashCardCompleteSound = this.flashCardCompleteSound

    this.wasSidebarOpen = this.$store.state.reduceButton
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true)

    if (localStorage.getItem('flashCardSettings')) {
      const settings = JSON.parse(localStorage.getItem('flashCardSettings'))
      Object.keys(this.settings).forEach((key) => {
        if (settings[key]) this.settings[key] = settings[key]
      })
    }

    this.cardTransition()
    this.fetchSetDetails()
    window.addEventListener('keydown', this.keyPressed)
  },
  beforeDestroy () {
    if (!this.wasSidebarOpen) this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
    window.addEventListener('keydown', this.keyPressed)
  }
}
</script>
<style lang="scss">
#FcRenderer {
  cursor: url('~@/assets/images/cursor/cursor-auto.png'), auto;
  padding-top: 2.85rem;

  button {
    cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto;
  }

  .cursor-pointer {
    cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto !important;
  }

  .FcAppScreen {
    min-height: 75vh;
    padding: 3rem;
  }

  .FcAppParent {
    max-width: 1250px;
    width: 100%;
    height: 100%;
    font-size: 32px;
    font-weight: 600;
    align-items: center;
    justify-content: center;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: flex;
  }

  .FcAppContainer {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    display: flex;
  }

  .fcLeftArrow {
    z-index: 99;
  }

  .fcRightArrow {
    z-index: 99;
  }

  .fcCard {
    width: 100%;
    height: 100%;
    margin-left: 2.5%;
    margin-right: 2.5%;
    max-width: 850px;
  }
}
</style>
